import { Col, Form, Row } from 'antd';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FileSelect from '../../../../../../../../../components/form/upload/SingleUpload';

const Documents = ({ gutter, title, index }) => {
  // eslint-disable-next-line no-unused-vars
  const [clientDocumentFile, setClientDocumentFile] = useState([]);

  return (
    <>
      <Row>
        <Col span={24}>
          <p className="personalDocumentsForm__title">{title}</p>
        </Col>
      </Row>
      <Row gutter={gutter}>
        <Col span={24}>
          <p>Sube las imágenes de tu Cédula de Identidad por ambos lados</p>
          <p>Archivos JPG, PNG o PDF - Tamaño máximo 5MB.</p>
        </Col>
      </Row>
      <Row gutter={gutter}>
        <Col lg={12} xs={24}>
          <Form.Item
            name={['legalRepresentatives', index, 'ciDocuments']}
            rules={[{ required: true, message: 'Documento obligatorio' }]}
          >
            <FileSelect
              accept={'image/*,.pdf'}
              maxSizeKb={10240}
              maxFileCount={3}
              onFileListChange={setClientDocumentFile}
              enableFileList
            >
              Cargar Documento
            </FileSelect>
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

Documents.propTypes = {
  gutter: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  index: PropTypes.string.isRequired,
};

export default Documents;
